import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

export default function ChartAmount01(props: ChartAmountPropTypes) {
  const [porcentagemUtilizada, setPorcentagemUtilizada] =
    useState<ApexNonAxisChartSeries>([0]);
  const [chartOptionsState, setChartOptionsState] = useState<{
    options: ApexCharts.ApexOptions;
  }>({
    options: {
      chart: {
        type: 'radialBar',
        offsetY: -20,
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          hollow: {
            margin: 0,
            size: "45%",
            background: "#f4f0f0",
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: "front",
            dropShadow: {
              enabled: true,
              top: 1,
              left: 0,
              blur: 3,
              opacity: 0.1,
            },
          },
          track: {
            background: "#fffafa",
            strokeWidth: "85%",
            margin: 2, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: -1,
              left: 0,
              blur: 2,
              opacity: 0.1,
            },
          },
          dataLabels: {
            show: true,
            name: {
              offsetY: 0,
              show: false,
              color: "#4c4c4c",
              fontSize: "12px",
            },
            value: {
              formatter: (val) => val.toFixed(0).toString() + " %",
              offsetY: -2,
              color: "#4c4c4c",
              fontSize: "22px",
              show: true,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        // gradient: {
        //   shade: "dark",
        //   type: "horizontal",
        //   shadeIntensity: 0.5,
        //   gradientToColors: ["#ABE5A1"],
        //   inverseColors: true,
        //   opacityFrom: 1,
        //   opacityTo: 1,
        //   stops: [0, 100],
        // },

        gradient: {
          shade: "light",
          type: "horizontal",
          shadeIntensity: 0.4,
          gradientToColors: ["#ABE5A1"],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: "round",
      },
      labels: ["VARIAÇÃO"],
    },
  });

  useEffect(() => {
    setPorcentagemUtilizada([props.porcentagemUtilizada || 0]);
  }, [props]);

  return (
    <div className="app">
      <div className="chart-row">
        <div className="col radial-chart">
          <ReactApexChart
            options={chartOptionsState.options}
            series={porcentagemUtilizada}
            type="radialBar"
            width="300"
          />
        </div>
      </div>
    </div>
  );
}

interface ChartAmountPropTypes {
  porcentagemUtilizada?: number;
}
